<template>
    <div>
        <breadcrumb :routerList="[{to:'/chanp/salesTableSh',title:'销售样表（上海直销）'},{title:'销量样表（上海直销）编辑页面'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form :model="f" label-position="right" ref="f" :inline="true"
                              class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>销售样表信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Bianjish">
                                            <el-form-item label="产品大类" class="h-elformWrap-2">
                                                <el-input v-model="f.prodseries" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品型号" class="h-elformWrap-2">
                                                <el-input v-model="f.promodel" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品编码" class="h-elformWrap-2">
                                                <el-input v-model="f.prodcode" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="状态" class="h-elformWrap-2">
                                                <brselect category="prodstatus" :v="f.prodstatus" v-model="f.prodstatus"/>
                                            </el-form-item>
                                            <el-form-item label="型号属性" class="h-elformWrap-2">
                                                <el-select v-model="f.protype" placeholder="请选择">
                                                    <el-option value="自产">自产</el-option>
                                                    <el-option value="OEM">OEM</el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="采购价格" class="h-elformWrap-2">
                                                <el-input  v-model="f.cgprice"></el-input>
                                            </el-form-item>
                                            <el-form-item label="币种" class="h-elformWrap-2">
                                                <brselect category="YLCurrency" :v="f.currency" v-model="f.currency"/>
                                            </el-form-item>
                                            <el-form-item label="供应商编码" class="h-elformWrap-2">
                                                <el-input  v-model="f.supplierId"></el-input>
                                            </el-form-item>
                                            <el-form-item label="供应商名称" class="h-elformWrap-2">
                                                <el-input  v-model="f.supplierName"></el-input>
                                            </el-form-item>
                                            <el-form-item label="品牌" class="h-elformWrap-2">
                                                <el-input  v-model="f.pinpai"></el-input>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="updatelist">确认修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>
	import ss from '../../api/SystemService'
	export default {
		data() {
			return {
					//带线表单
				f: {
				},
				loading: false,
			}
		},
		created() {
			this.query();
		},
		methods: {
			query() {
				this.f.id = this.$route.query.id;
				ss.salesListSh.selectById(this.f.id).then(rd => {
					this.f = rd;
				})
			},
			backS() {
				this.$router.push({path: "/chanp/salesTableSh"});
			},
			updatelist() {
				ss.salesListSh.updateById(this.f).then(rd => {
					this.$msg.msgs("操作成功");
					this.$router.push({path: "/chanp/salesTableSh"});
				})
			},

		}
	}
</script>

<style>
	.Bianjish .el-form-item__label {
		width: 26%;
		text-align: right;
	}

	.Bianjish .el-form-item__content {
		width: 74%;
	}

	.Bianjish .h-elformWrap-2 {
		width: 33.333% !important;
		padding-right: 0.5rem
	}

	.Bianjish .h-elformWrap-1 {
		width: 100%;
		padding-right: 0.5rem
	}
</style>
